<template>
    <div class="row" v-loading="isLoading">
        <div v-if="field_errors.hasOwnProperty('deal_id')" class="help-block invalid-feedback d-block" v-html="field_errors['deal_id'][0]"/>
        <div class="form-group col-6">
            <label class="mb-0" :for="'discount' + _uid">Скидка</label>
            <input type="number" class="form-control" name="discount" :id="'initial_payment' + _uid" v-model="discount">
            <div v-if="field_errors.hasOwnProperty('discount')" class="help-block invalid-feedback d-block" v-html="field_errors['discount'][0]"/>
        </div>
        <div class="form-group col-12 text-right">
            <button @click="generateForDeal" class="btn btn-light"><i class="fas fa-download mr-2"></i>Скачать документ</button>
        </div>
    </div>
</template>

<script>
import formMixin from "../formMixin";
import _ from "lodash";

export default {
    name: "SoglasheniePoSkidkeIDopam",
    mixins: [formMixin],
    props: {
        form_name: {
            type: String,
            required: true,
        },
        deal: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        isLoading: false,
        discount: 1000,
        field_errors: {},
    }),
    computed: {
        form_params() {
            return {
                form_name: this.form_name,
                discount: this.discount,
                deal_id: this.deal.id,
            };
        }
    }
}
</script>

<style scoped>

</style>
